import { render, staticRenderFns } from "./NoteIndicator.vue?vue&type=template&id=23a1c264&scoped=true"
import script from "./NoteIndicator.vue?vue&type=script&lang=ts"
export * from "./NoteIndicator.vue?vue&type=script&lang=ts"
import style0 from "./NoteIndicator.vue?vue&type=style&index=0&id=23a1c264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1c264",
  null
  
)

export default component.exports